import { DashboardConfig } from '../../common/components/dashboards/types';
import { AlexDashboardChartConfig } from './alex/alex_dashboard_config';
import { IPexHcSimulationDashboardConfig } from './i_pex/hc-simulation-dashboard/hc-simulation-dashboard-config';
import { IPexHumanCapitalDashboardConfig } from './i_pex/human-capital-dashboard/i-pex-human-capital-dashboard-config';
import { IPexRecruitmentStoryboardDashboardConfig } from './i_pex/recruitment-storyboard/recruitment-storyboard-dashboard-config';
import { JTDashboardChartConfig } from './jt/jt_dashboard_config';
import { JTBHcSimulationDashboardConfig } from './jtb/hc-simulation/hc-simulation-dashboard-config';
import { JTBHumanCapitalManagementDashboardConfig } from './jtb/jtb-human-capital-management-db/jtb-hcm-dashboard-config';
import { JTBDashboardChartConfig } from './jtb/jtb-kpi-db/jtb_dashboard_config';
import { MixiHumanCapitalDashboardConfig } from './mixi/human-capital/human-capital-dashboard_config';
import { NecnsiHcSimulationDashboardConfig } from './necnsi/hc-simulation/hc-simulation-dashboard-config';
import { NikkiGlobalHrAsDashboardConfig } from './nikki/global-hr-as/nikki-global-hr-as-dashboard-config';
import { NikkiHcSimulationDashboardConfig } from './nikki/hc-simulation/hc-simulation-dashboard-config';
import { NikkiHeadcountDashboardConfig } from './nikki/headcount/nikki_headcount_dashboard_config';
import { NikkiLeaversDashboardConfig } from './nikki/leavers/nikki_leavers_dashboard_config';
import { NikkiTurnoverDashboardConfig } from './nikki/turnover/nikki_turnover_dashboard_config';
import { NssolHcSimulationDashboardConfig } from './nssol/hc-simulation/hc-simulation-dashboard-config';
import { PatagoniaHumanResourcesDashboardConfig } from './patagonia/patagonia_human_resources/patagonia_human_resources_dashboard.config';
import { ShipHealthcareHcSimulationDashboardConfig } from './shiphealthcare/hc-simulation/hc-simulation-dashboard-config';
import { ShipHealthcareDashboardChartConfig } from './shiphealthcare/shiphealthcare_dashboard_config';
import { ShipHealthcareDashboardChartConfig2 } from './shiphealthcare/shiphealthcare_dashboard_config_2';
import { TdHoldingsHumanCapitalDashboardConfig } from './td_holdings/td-holdings-human-capital-dashboard-config';
import { WashiHcSimulationDashboardConfig } from './washi/hc-simulation-dashboard/hc-simulation-dashboard-config';
import { WashiHumanCapitalManagementDashboardConfig } from './washi/human-capital/human-capital-management-dashboard_config';

export const defaultDashboardConfigs: DashboardConfig[] = [];
export const jtDashboardConfigs: DashboardConfig[] = [JTDashboardChartConfig];
export const shipHealthcareDashboardConfigs: DashboardConfig[] = [
  ShipHealthcareDashboardChartConfig,
  ShipHealthcareDashboardChartConfig2,
  ShipHealthcareHcSimulationDashboardConfig,
];
export const swanDashboardConfigs: DashboardConfig[] = [
  AlexDashboardChartConfig,
];
export const allDashboardConfigs: DashboardConfig[] = [
  AlexDashboardChartConfig,
  JTBDashboardChartConfig,
];

export const jtbDashboardConfigs: DashboardConfig[] = [
  JTBDashboardChartConfig,
  JTBHumanCapitalManagementDashboardConfig,
  JTBHcSimulationDashboardConfig,
];

export const nikkiDashboardConfigs: DashboardConfig[] = [
  NikkiHeadcountDashboardConfig,
  NikkiTurnoverDashboardConfig,
  NikkiLeaversDashboardConfig,
  NikkiGlobalHrAsDashboardConfig,
  NikkiHcSimulationDashboardConfig,
];

export const mixiDashboardConfigs: DashboardConfig[] = [
  MixiHumanCapitalDashboardConfig,
];
export const washiDashboardConfigs: DashboardConfig[] = [
  WashiHumanCapitalManagementDashboardConfig,
  WashiHcSimulationDashboardConfig,
];

export const patagoniaDashboardConfigs: DashboardConfig[] = [
  PatagoniaHumanResourcesDashboardConfig,
];

export const necnsiDashboardConfigs: DashboardConfig[] = [
  NecnsiHcSimulationDashboardConfig,
];

export const nssolDashboardConfigs: DashboardConfig[] = [
  NssolHcSimulationDashboardConfig,
];

export const iPexDashboardConfigs: DashboardConfig[] = [
  IPexRecruitmentStoryboardDashboardConfig,
  IPexHumanCapitalDashboardConfig,
  IPexHcSimulationDashboardConfig,
];

export const tdHoldingsDashboardConfigs: DashboardConfig[] = [
  TdHoldingsHumanCapitalDashboardConfig,
];
